import { createContext, useState, useEffect } from 'react';
import { getFeriados, postFeriado,  updateFeriado } from '../services/feriados.services';

export const FeriadosContext = createContext();

export const FeriadosProvider = ({ children }) => {
  const [feriados, setFeriados] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar feriados al iniciar
  useEffect(() => {
    cargarFeriados();
  }, []);

  const cargarFeriados = async () => {
    try {
      const data = await getFeriados();
      setFeriados(data);
    } catch (error) {
      console.error('Error al cargar feriados:', error);
    } finally {
      setLoading(false);
    }
  };

  const agregarFeriado = async (nuevoFeriado) => {
    try {
      const feriadoGuardado = await postFeriado(nuevoFeriado);
      setFeriados([...feriados, feriadoGuardado]);
      return feriadoGuardado;
    } catch (error) {
      console.error('Error al agregar feriado:', error);
      throw error;
    }
  };

  const actualizarFeriado = async (id, feriado) => {
    try {
      const updated = await updateFeriado(id, feriado);
      setFeriados(feriados.filter(feriado => feriado.id !== id));
      return updated;
    } catch (error) {
      console.error('Error al eliminar feriado:', error);
      throw error;
    }
  };

  const esFeriado = (fecha) => {
    return feriados.some(feriado => feriado.fecha === fecha);
  };

  return (
    <FeriadosContext.Provider value={{ 
      feriados, 
      agregarFeriado, 
      actualizarFeriado, 
      esFeriado,
      loading 
    }}>
      {children}
    </FeriadosContext.Provider>
  );
};